
export const DEBUG_LOGGING = 'DEBUG_LOGGING'
export function setDebugLogging(debugLogging) {
  localStorage.setItem('wm.showDebugLogs', debugLogging)
  return { type: DEBUG_LOGGING, value: debugLogging }
}
